import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import ajax from '@/utils/ajax';

import { Staff } from '../types/staff';

export const staffRepository = {
  async getStaffList(host: string): Promise<Staff[]> {
    const path = `${host}/api/dugout/staff/?healthie_id__isnull=false`;
    const response = await ajax.get({ url: path });

    return response.data;
  }
};

const StaffRepository = (): { getStaffList(): Promise<Staff[]> } => {
  const { host } = useContext(AppContext);
  return {
    async getStaffList(): Promise<Staff[]> {
      return staffRepository.getStaffList(host);
    }
  };
};

export default StaffRepository;
